<template>
  <div id="ProductionProgressView">
    <el-card class="table_searchbar" style="height: auto;padding-bottom: 30px;">
      <div class="tabs" v-if="selectedSplit.productionType == 1 || selectedSplit.productionType == 0">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="进度详情" name="0"></el-tab-pane>
          <el-tab-pane v-if="selectedSplit.splitStatus > 8" label="问题报告" name="1"></el-tab-pane>
        </el-tabs>
      </div>
      <el-row class="order_product_table" v-if="(selectedSplit.productionType == 1 || selectedSplit.productionType == 0) && activeName == 0">
        <el-row :gutter="20" style="margin-top: 10px;">
          <el-col :span="6">
            <span class="label">工单号：</span>
            <el-input disabled style="width:240px" size="small" v-model="selectedSplit.newProductionBatchCode" placeholder="工单号"></el-input>
            <!-- <span class="value" style="width:210px">{{selectedSplit.productionBatchCode?selectedSplit.productionBatchCode:'&nbsp;'}} </span> -->
          </el-col>

          <el-col :span="6">
            <span class="label">订单号：</span>
            <el-input disabled style="width:240px" size="small" v-model="selectedSplit.erpBusinessOrderCode" placeholder=""></el-input>
            <!-- <span class="value" style="width:212px">{{selectedSplit.orderCode||selectedSplit.erpBusinessOrderCode
							?selectedSplit.orderCode||selectedSplit.erpBusinessOrderCode:'&nbsp;'}}</span> -->
          </el-col>
          <el-col :span="6">
            <span class="label">工单状态：</span>
            <el-input disabled style="width:240px" size="small" v-model="selectedSplit.splitStatusText" placeholder=""></el-input>
            <!-- <span class="value">{{selectedSplit.splitStatus|parseStatus}} </span> -->
          </el-col>
          <el-col :span="6">
            <span class="label">物料编码：</span>
            <el-input disabled style="width:240px" size="small" v-model="showMaterialCode" placeholder=""></el-input>
            <!-- <span class="value">{{showMaterialCode?showMaterialCode:'&nbsp;'}}</span> -->
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 15px;">
          <el-col :span="6">
            <span class="label">物料名称：</span>
            <el-input disabled style="width:240px" size="small" v-model="showMaterialName" placeholder=""></el-input>
            <!-- <span class="value">{{showMaterialName?showMaterialName:'&nbsp;'}}</span> -->
          </el-col>
          <el-col :span="6">
            <span class="label">材质：</span>
            <el-input disabled style="width:240px" size="small" v-model="selectedSplit.materialQualityName" placeholder=""></el-input>
            <!-- <span class="value">{{showMaterialName?showMaterialName:'&nbsp;'}}</span> -->
          </el-col>
          <el-col :span="6">
            <span class="label">物料类型：</span>
            <el-input disabled style="width:240px" size="small" v-model="showMaterialType" placeholder="物料类型"></el-input>
            <!-- <span class="value" >{{showMaterialType?showMaterialType:'&nbsp;'}}</span> -->
          </el-col>
          <el-col :span="6">
            <span class="label">生产数量：</span>
            <el-input disabled style="width:240px" size="small" v-model="selectedSplit.splitCount" placeholder="生产数量"></el-input><span>{{ selectedSplit.unitType }}</span>
            <!-- <span class="value">{{selectedSplit.splitCount?selectedSplit.splitCount:'&nbsp;'}}  -->
          </el-col>

          <!-- <span class="label" v-if='permission.btn_pickMaterial_lookPickMaterial'>领料进度：</span>
					<span class="y_lookValue" v-if='permission.btn_pickMaterial_lookPickMaterial' @click="MaterialDialogClick()">查看</span> -->
        </el-row>
        <el-row :gutter="20" style="margin-top: 15px;">
          <el-col :span="6">
            <span class="label">订单数量：</span>
            <el-input disabled style="width:240px" size="small" v-model="selectedSplit.orderCount" placeholder="订单数量"></el-input>
            <!-- <span class="value">{{selectedSplit.orderCount?selectedSplit.orderCount:'&nbsp;'}} {{selectedSplit.unitType}}</span> -->
          </el-col>
          <el-col :span="6">
            <span class="label">客户名称：</span>
            <el-input disabled style="width:240px" size="small" v-model="selectedSplit.customerName" placeholder=""></el-input>
          </el-col>
          <el-col :span="6">
            <span class="label">商标：</span>
            <el-input disabled style="width:240px" size="small" v-model="selectedSplit.trademark" placeholder=""></el-input>
          </el-col>
          <!-- <el-col :span="6">
						<span class="label" style="margin-left: -40px;width: 112px;">累计不合格数量：</span>
						<el-input disabled style="width:240px" size="small" v-model="selectedSplit.totalActualUnqualifiedProcessCount" placeholder=""></el-input>
					</el-col> -->
          <el-col :span="6">
            <span class="label" style="margin-left: -28px;width: 100px;">累计报废数量：</span>
            <el-input disabled style="width:240px" size="small" v-model="selectedSplit.totalActualSpoiledProcessCount" placeholder=""></el-input>
          </el-col>
          <!-- <span class="value" >{{selectedSplit.totalActualUnqualifiedProcessCount}}</span>

					
					<span class="value" >{{selectedSplit.totalActualSpoiledProcessCount}}</span>
					<span class="label">计划开始时间：</span>
					<span class="value" style="width:176px">{{selectedSplit.planStartTime|showSubmitTime(true)}}</span>

					<span class="label">计划完工时间：</span>
					<span class="value" >{{selectedSplit.planEndTime|showSubmitTime(true)}}</span>

					

					
					<span class="value" style="width:240px">{{selectedSplit.splitRemark}}</span> -->
        </el-row>
        <el-row :gutter="20" style="margin-top: 15px;">
          <el-col :span="6">
            <span class="label">计划时间：</span>
            <el-input disabled style="width:240px" size="small" v-model="selectedSplit.planTime" placeholder=""></el-input>
          </el-col>
          <el-col :span="12">
            <span class="label">拆分说明：</span>
            <el-input disabled style="width:664px" size="small" v-model="selectedSplit.splitRemark" placeholder=""></el-input>
          </el-col>
        </el-row>

        <el-row :gutter="20" style="margin-bottom:10px">
          <el-col v-for="item in propertyExtendListCopy" :key="`'${item.id}'`" :span="6" style="position:relative;margin-top:15px">
            <span class="title custome-title" style="width: 112px;margin-left: -28px;overflow: hidden;">{{ item.propertyName }}：</span>
            <div class="value">
              <el-input v-if="item.inputType == 0" disabled :maxlength="50" v-model="item.propertyValue" placeholder="请输入" :style="{ maxWidth: '240px' }"></el-input>
              <el-select v-if="item.inputType == 1" disabled v-model="item.propertyValue" remote placeholder="请选择" style="width:200px" clearable :style="{ maxWidth: '240px' }">
                <el-option v-for="value in item.values" :key="value" :label="value" :value="value"></el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 15px;display:flex">
          <span class="label" style="width:82px">SOP：</span>
          <div v-if="selectedSplit.moduleImageURLList && selectedSplit.moduleImageURLList.length > 0" style="display:flex">
            <div v-for="(item, index) in selectedSplit.moduleImageURLList" :key="index" style="width:40px;height:40px;margin-right:18px">
              <div>
                <div class="file-icon-container" :style="{ backgroundImage: `url(${item.filePath})` }" @click="showFile(item.url)"></div>
              </div>
            </div>
          </div>
        </el-row>
        <el-row style="margin-top: 15px;">
          <el-table class="progress_table" :cell-style="cellStyle" maxHeight="300" :cell-class-name="showCellClass" :data="progressData" tooltip-effect="dark" :span-method="objectSpanMethod" border>
            <el-table-column label="序号" width="60" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{ scope.row.index }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="procedureName" label="工序名称" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="totalProcessStatus" :formatter="parseTotalProcessStatus" label="总工序状态" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="planTime" label="计划生产时间" min-width="180" show-overflow-tooltip></el-table-column>
            <!-- <el-table-column prop='actualStartTime' label='实际开始时间' min-width='100' show-overflow-tooltip :formatter='$commonUtil.changeToDate'></el-table-column>
						<el-table-column prop='actualEndTime' label='实际结束时间' min-width='100' show-overflow-tooltip :formatter='$commonUtil.changeToDate'></el-table-column> -->
            <!-- <el-table-column prop='factoryModelName' label='机组' min-width='80' show-overflow-tooltip></el-table-column> -->
            <!-- <el-table-column prop='deviceCode' label='设备编号' min-width='80' :formatter="parseDevice" show-overflow-tooltip v-if="splitType!=0"></el-table-column> -->
            <el-table-column prop="workerName" label="执行者/执行组" min-width="80" show-overflow-tooltip> </el-table-column>
            <el-table-column prop="productionEfficiency" label="实际加工节拍(s)" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="executeCount" label="计划数量" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qualifiedProcessCount" label="合格数" min-width="100" show-overflow-tooltip></el-table-column>

            <el-table-column prop="actualFinishedAmount" label="实际合格数" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="unqualifiedProcessCount" label="不合格数" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="actualUnqualifiedProcessCount" label="实际不合格数" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="operationalWasteCount" label="工废数" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="actualOperationalWasteCount" label="实际工废数" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="materialWasteCount" label="料废数" min-width="70" show-overflow-tooltip></el-table-column>
            <el-table-column prop="actualMaterialWasteCount" label="实际料废数" min-width="70" show-overflow-tooltip></el-table-column>
            <el-table-column prop="finishedAmount" label="工序总合格数" min-width="70" show-overflow-tooltip></el-table-column>
            <!-- <el-table-column prop='qualifiedProcessCount' label='报工数' min-width='70' show-overflow-tooltip></el-table-column>
						
						<el-table-column prop='actualFinishedAmount' label='有效报工数' width='90' >
							<template slot-scope="scope">
								<el-tooltip :content="''+scope.row.actualFinishedAmount" placement="top">
									<span style="position: relative;top: 4px;margin-right:0px;width: 41px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;display: inline-block;" >{{scope.row.actualFinishedAmount}}</span>
								</el-tooltip>
								<el-button v-if='permission.btn_productionPlan_updateActualFinishedAmount'  icon='el-icon-edit' @click="showUpdataCount(scope.row)" style="position: relative;top: 6px;padding:4px;margin:none;border:none;vertical-align: top;"></el-button>
							</template>
						</el-table-column> -->
            <!-- <el-table-column prop='planState' :formatter='parsePlanState' label='工序状态' min-width='80' show-overflow-tooltip></el-table-column> -->
            <el-table-column prop="progress" label="进度" min-width="80" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-progress :text-inside="true" :stroke-width="18" :color="scope.row.color" :percentage="getProgress(scope.row)"></el-progress>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-row>

      <el-row class="order_product_table" v-if="selectedSplit.productionType == 4 || selectedSplit.productionType == 2">
        <el-row class="order_item_title">{{ selectedSplit.productionType == 2 ? "外购类型进度" : "外协类型进度" }}：</el-row>
        <el-row style="margin-top: 10px;">
          <span class="label">订单编号：</span>
          <span class="value">{{ selectedSplit.orderCode ? selectedSplit.orderCode : "&nbsp;" }}</span>

          <span class="label">抵扣库存：</span>
          <span class="value">{{ selectedSplit.needStockAmount }} {{ selectedSplit.unitType }}</span>
        </el-row>
        <el-row>
          <span class="label">物料名称：</span>
          <span class="value">{{ showMaterialName ? showMaterialName : "&nbsp;" }}</span>

          <span class="label">物料编码：</span>
          <span class="value">{{ showMaterialCode ? showMaterialCode : "&nbsp;" }}</span>

          <span class="label">物料型号：</span>
          <span class="value">{{ showMaterialModel ? showMaterialModel : "&nbsp;" }}</span>

          <span class="label">物料类型：</span>
          <span class="value">{{ showMaterialType ? showMaterialType : "&nbsp;" }}</span>
          <!-- <span class="label" v-if='permission.btn_pickMaterial_lookPickMaterial'>领料进度：</span>
					<span class="y_lookValue" v-if='permission.btn_pickMaterial_lookPickMaterial' @click="MaterialDialogClick()">查看</span> -->
        </el-row>
        <!-- <el-row >
					<span class="label">零件名称：</span>
					<span class="value">{{selectedSplit.partName?selectedSplit.partName:'&nbsp;'}}</span>
					<span class="label">零件编码：</span>
					<span class="value">{{selectedSplit.partCode?selectedSplit.partCode:'&nbsp;'}}</span>
					<span class="label">零件型号：</span>
					<span class="value">{{selectedSplit.partModel?selectedSplit.partModel:'&nbsp;'}}</span>
				</el-row> -->

        <el-table class="progress_table" :data="progressData" tooltip-effect="dark">
          <el-table-column label="序号" min-width="60" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="productionCount" label="数量" min-width="60" show-overflow-tooltip></el-table-column>
          <el-table-column prop="workerName" label="执行者" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="planningEndTime" label="交付时间" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="actualStartTime" label="实际开始时间" min-width="100" show-overflow-tooltip :formatter="$commonUtil.changeToDate"></el-table-column>
          <el-table-column prop="actualEndTime" label="实际结束时间" min-width="100" show-overflow-tooltip :formatter="$commonUtil.changeToDate"></el-table-column>
          <el-table-column prop="qualifiedProcessCount" label="完成数量" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="actualFinishedAmount" label="实际数量" width="90">
            <template slot-scope="scope">
              <el-tooltip :content="'' + scope.row.actualFinishedAmount" placement="top">
                <span style="position: relative;top: 4px;margin-right:0px;width: 41px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;display: inline-block;">{{
                  scope.row.actualFinishedAmount
                }}</span>
              </el-tooltip>
              <el-button
                v-if="permission.btn_productionPlan_updateActualFinishedAmount"
                icon="el-icon-edit"
                @click="showUpdataCount(scope.row)"
                style="position: relative;top: 6px;padding:4px;margin:none;border:none;vertical-align: top;"
              ></el-button>
            </template>
          </el-table-column>
          <el-table-column prop="unqualifiedProcessCount" label="不合格数量" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="actualUnqualifiedProcessCount" label="实际不合格数量" width="90">
            <template slot-scope="scope">
              <el-tooltip :content="'' + scope.row.actualFinishedAmount" placement="top">
                <span style="position: relative;top: 4px;margin-right:0px;width: 41px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;display: inline-block;">{{
                  scope.row.actualFinishedAmount
                }}</span>
              </el-tooltip>
              <el-button
                v-if="permission.btn_productionPlan_updateActualFinishedAmount"
                icon="el-icon-edit"
                @click="showUpdataCount(scope.row)"
                style="position: relative;top: 6px;padding:4px;margin:none;border:none;vertical-align: top;"
              ></el-button>
            </template>
          </el-table-column>
          <el-table-column prop="progress" label="进度" min-width="100" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-progress :text-inside="true" :stroke-width="18" :color="scope.row.color" :percentage="scope.row.progress"></el-progress>
            </template>
          </el-table-column>
          <el-table-column prop="procedureName" label="工序图纸" min-width="50" show-overflow-tooltip>
            <template slot-scope="scope">
              <div v-if="scope.row.technologyFileName" style="width:42px;height:42px;">
                <el-tooltip class="item" effect="dark" :content="scope.row.technologyFileName" placement="bottom-end">
                  <div class="file-icon-container" :style="{ backgroundImage: `url(${scope.row.filePath})`, top: `-6px` }" @click="showFile(scope.row.technologyFileUrl)"></div>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="7" show-overflow-tooltip> </el-table-column>
        </el-table>
      </el-row>

      <el-table
        class="progress_table"
        :data="errList"
        tooltip-effect="dark"
        v-if="activeName == 1 && selectedSplit.splitStatus > 8"
        :height="errList.length >= 8 ? 324 : errList.length ? 46 * errList.length + 46 : 'auto'"
        style="width: 100%;margin-bottom:10px;overflow-y: auto;max-height:324px"
      >
        <el-table-column prop="procedureName" label="工序名称" min-width="60" show-overflow-tooltip></el-table-column>
        <el-table-column prop="workerName" label="执行者" min-width="40" show-overflow-tooltip></el-table-column>
        <el-table-column prop="type" label="类型" min-width="40" show-overflow-tooltip></el-table-column>
        <el-table-column prop="count" label="数量" min-width="40" show-overflow-tooltip></el-table-column>
        <el-table-column prop="time" :formatter="parseTime" label="提交时间" min-width="60" show-overflow-tooltip></el-table-column>
        <el-table-column prop="reason" label="原因" min-width="200"></el-table-column>
      </el-table>
      <el-row>
        <el-row class="operateBtn-wrap" style="text-align: center;margin-top:16px">
          <el-button type="primary" icon="el-icon-arrow-left" size="small" @click="backToOrderItemView">返回</el-button>
          <el-button type="primary" icon="el-icon-download" size="small" @click="exportList">导出</el-button>
        </el-row>
      </el-row>
    </el-card>

    <el-dialog title="修改数量" center :visible.sync="isShowDialog" width="70%" :close-on-click-modal="false">
      <div style="margin-top:-14px;margin-bottom:26px">
        <el-form ref="form" :model="form" :rules="rules">
          <el-table :data="dataList" stripe>
            <el-table-column label="报工时间" min-width="100" prop="submitTime">
              <template slot-scope="scope">
                <el-form-item>
                  <span>{{ scope.row.submitTime | showSubmitTime }}</span>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="有效生产数量" prop="submitAmount" min-width="100">
              <template slot-scope="scope">
                <el-form-item>
                  <span>{{ scope.row.submitAmount }}</span>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="实际完成数量" prop="actualAmount" min-width="150">
              <template slot-scope="scope">
                <el-form-item :prop="`dataList[${scope.$index}].actualAmount`" :rules="rules.actualAmount">
                  <el-input v-model="scope.row.actualAmount" :maxlength="9" style="width:80px"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="实际不合格数量" prop="actualUnqualifiedProcessCount" min-width="150">
              <template slot-scope="scope">
                <el-form-item :prop="`dataList[${scope.$index}].actualUnqualifiedProcessCount`" :rules="rules.actualUnqualifiedProcessCount">
                  <el-input v-model="scope.row.actualUnqualifiedProcessCount" :maxlength="9" style="width:80px"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="实际报废数量" prop="actualSpoiledProcessCount" min-width="150">
              <template slot-scope="scope">
                <el-form-item :prop="`dataList[${scope.$index}].actualSpoiledProcessCount`" :rules="rules.actualUnqualifiedProcessCount">
                  <el-input v-model="scope.row.actualSpoiledProcessCount" :maxlength="9" style="width:80px"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </div>
      <div style="text-align: center;">
        <el-button size="small" @click="isShowDialog = false" style="margin-left: 20px;">取 消</el-button>
        <el-button type="primary" size="small" @click="updataCount">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="领料进度" :visible.sync="MaterialDialogVisible" width="60%" height="50%" center>
      <el-form>
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="y_flex">
              <span class="key">物料名称：</span>
              <span>{{ showMaterialName ? showMaterialName : "&nbsp;" }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="y_flex">
              <span class="key">物料编码：</span>
              <span>{{ showMaterialCode ? showMaterialCode : "&nbsp;" }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="y_flex">
              <span class="key">物料型号：</span>
              <span>{{ showMaterialModel ? showMaterialModel : "&nbsp;" }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 30px;">
          <el-col :span="8">
            <div class="y_flex">
              <span class="key">生产数量：</span>
              <span>{{ clickLooklist.splitCount }} {{ selectedSplit.unitType }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="y_flex">
              <span class="key">需求总量：</span>
              <span>{{ clickLooklist.splitNeedAmount }} {{ selectedSplit.unitType }}</span>
            </div>
          </el-col>
          <el-col :span="8"> </el-col>
        </el-row>
      </el-form>
      <el-table stripe :data="pickMaterialsList" style="width: 100%;margin-bottom:10px; margin-top: 30px;height: 300px;overflow-y: auto">
        <el-table-column label="序号" min-width="80" type="index"></el-table-column>
        <el-table-column label="物料名称" min-width="100" prop="materialName"></el-table-column>
        <el-table-column label="物料编码" min-width="100" prop="materialCode"></el-table-column>
        <el-table-column label="物料型号" min-width="100" prop="specification"></el-table-column>
        <el-table-column label="单位" min-width="100" prop="unitType"></el-table-column>
        <el-table-column label="抵扣库存" min-width="140" prop="needAmount"></el-table-column>
        <el-table-column label="已领料数" min-width="140" prop="pickAmount"></el-table-column>
        <el-table-column label="操作" min-width="180">
          <template slot-scope="scope">
            <!--<el-button type="text" size="small" v-if="scope.row.pickAmount < scope.row.needAmount || scope.row.pickAmount > scope.row.needAmount"  @click="CancellationClick(scope.row)" >取消抵扣</el-button>-->
            <el-button v-if="scope.row.pickAmount < scope.row.needAmount && permission.btn_pickMaterial_accomplishPickMaterial" type="text" size="small" @click="materialClick(scope.row)"
              >完成领料</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="MaterialDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import commom from "@/util/CommonUtils";
export default {
  name: "ProductionProgressView",
  props: {
    selectedSplit: Object,
    propertyExtendList: Array
  },
  data() {
    return {
      rules: {
        actualAmount: [
          { required: true, message: "请输入完成数量", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (Number(value) >= 0) {
                callback();
              } else {
                callback(new Error("数量不能小于零"));
              }
            },
            trigger: "blur"
          }
        ],
        actualUnqualifiedProcessCount: [
          { required: true, message: "请输入数量", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (Number(value) >= 0) {
                callback();
              } else {
                callback(new Error("数量不能小于零"));
              }
            },
            trigger: "blur"
          }
        ]
      },
      propertyExtendListCopy: [],
      MaterialData: [],
      MaterialDialogVisible: false,
      dataList: [],
      isShowDialog: false,
      errList: [],
      form: {
        dataList: [],
        planId: null
      },
      clickLooklist: [],
      pickList: [],
      pickMaterialsList: [],
      clickLookForm: {
        splitId: null,
        materialName: "",
        materialCode: "",
        specification: "",
        unitType: ""
      },
      totalProcessStatusOpt: [
        //总工序状态(0,未排产;1,部分派工;2,已派工;3,部分生产中;4,生产中;5,已完工;6,已关闭)
        { label: "未排产", value: 0 },
        { label: "部分派工", value: 1 },
        { label: "已派工", value: 2 },
        { label: "部分生产中", value: 3 },
        { label: "生产中", value: 4 },
        { label: "已完工", value: 5 },
        { label: "已关闭", value: 6 }
      ],
      planStateOpt: [
        //0待执行 1已办结 2-已延期 3-任务保存,并不是提交,4-执行中，5-已关闭，6-已暂停
        { label: "待执行", value: 0 },
        { label: "已办结", value: 1 },
        { label: "已延期", value: 2 },
        { label: "已保存", value: 3 },
        { label: "执行中", value: 4 },
        { label: "已关闭", value: 5 },
        { label: "已暂停", value: 6 }
      ],
      planId: null,
      activeName: "0",
      splitType: null,
      productionType: 0,
      planedProductionPlanList: null, //生成计划预安排
      productionNum: 0,
      progressData: [],
      progress: 0,
      permission: JSON.parse(localStorage.getItem("permission"))
    };
  },
  //el和data尚未初始化
  beforeCreate: function() {},
  //data初始化完成
  created: function() {},
  //el初始化完成
  beforeMount: function() {},
  //完成挂载
  mounted: function() {
    // if(!this.selectedSplit){}
    this.loadProductionInfo();
    this.loadPartData(this.selectedSplit.splitItemId);
    this.parseStatus(this.selectedSplit.splitStatus);
    this.parseCustomeValue();
    if (!this.selectedSplit.moduleImageURLList) {
      this.selectedSplit.moduleImageURLList = [];
    }
    this.selectedSplit.moduleImageURLList.forEach(item => {
      item.filePath = this.getFilePath(item.fileName);
    });
    if (this.selectedSplit.planStartTime) {
      this.selectedSplit.planTime = commonUtils.timestampToDate(this.selectedSplit.planStartTime, true) + "  —  " + commonUtils.timestampToDate(this.selectedSplit.planEndTime, true);
    } else {
      this.selectedSplit.planTime = "";
    }
    this.selectedSplit.newProductionBatchCode = this.selectedSplit.childProductionBatchCode || this.selectedSplit.productionBatchCode;
  },
  //更新dom时触发
  beforeUpdate: function() {},
  updated: function() {},
  activated: function() {},
  deactivated: function() {},
  beforeDestroy: function() {},
  destroyed: function() {},
  components: {},
  computed: {
    showMaterialName() {
      let data = this.selectedSplit;
      return data.materialName || "";
    },

    showMaterialCode() {
      let data = this.selectedSplit;
      return data.materialCode || "";
    },

    showMaterialModel() {
      let data = this.selectedSplit;
      return data.specification || "";
    },

    showMaterialType() {
      let data = this.selectedSplit;
      let str = "";
      if (data != null) {
        if (data.splitItemType == 1) {
          str = "零件";
        } else {
          str = "产品";
        }
      }
      return str;
    }
  },
  methods: {
    async getCustomeValueList(businessOrderSplitId) {
      let { code, data } = await this.$RequestUtil.getAsync({ url: "/api/businessOrderSplitPropertyExtend/listBusinessOrderSplitPropertyExtend", type: "sync", params: { businessOrderSplitId } });
      return data;
    },
    async parseCustomeValue() {
      let res = await this.getCustomeValueList(this.selectedSplit.splitItemId);
      this.propertyExtendListCopy = commonUtils.cloneObj(this.propertyExtendList);
      this.propertyExtendListCopy.forEach(item => {
        let index = res.findIndex(f => f.propertyExtendId == item.id);
        if (index > -1) {
          item.propertyValue = res[index].propertyValue;
          item.isDeleted = res[index].isDeleted;
          res.splice(index, 1);
        }
      });
      if (res.length > 0) {
        res.forEach(item => {
          this.propertyExtendListCopy.push({
            id: item.propertyExtendId,
            propertyName: item.propertyName,
            propertyValue: item.propertyValue,
            inputType: 0,
            values: [],
            isDeleted: item.isDeleted
          });
        });
      }
    },
    async loadProductionInfo() {
      let { data, code, msg } = await this.$RequestUtil.getAsync({ url: "/api/productionTask/statProductionTask", params: { splitId: this.selectedSplit.splitItemId } });
      log(data);
      if (data[0]) {
        this.selectedSplit.totalActualUnqualifiedProcessCount = data[0].totalActualUnqualifiedProcessCount;
        this.selectedSplit.totalActualSpoiledProcessCount = data[0].totalActualSpoiledProcessCount;
      }
    },

    parseTotalProcessStatus(rowData) {
      return (this.totalProcessStatusOpt.find(item => item.value == rowData.totalProcessStatus) || {}).label;
    },

    parsePlanState(rowData) {
      return (this.planStateOpt.find(item => item.value == rowData.planState) || {}).label;
    },

    MaterialDialogClick() {
      this.MaterialDialogVisible = true;
      let form = {};
      form = this.clickLookForm;
      form.splitId = this.selectedSplit.splitItemId;
      form.materialName = this.showMaterialName;
      form.materialCode = this.showMaterialCode;
      form.specification = this.showMaterialModel;
      form.unitType = this.selectedSplit.unitType;
      this.$RequestUtil.get({
        url: "/api/pickMaterial/lookPickMaterial",
        type: "sync",
        params: {
          splitId: form.splitId,
          materialName: form.materialName,
          materialCode: form.materialCode,
          specification: form.specification,
          unitType: form.unitType
        },
        success: res => {
          if (res.code == 0) {
            this.clickLooklist = res.data.currentPickMaterialDto;
            this.pickMaterialsList = res.data.pickMaterials;
          } else {
            this.$message.error(res.msg || res.message);
          }
        }
      });
    },

    exportList: function() {
      this.$confirm("是否确认导出?", "提示", {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let url = "/api/productionTask/exportProductionTask";
          let text = "报工进度报表.xls";
          let { code, data } = await this.$RequestUtil.getAsync({ url: "/api/auth/checkToken", type: "sync", params: {} });
          if (data == 0 || code != 0) {
            this.$message.error("当前登录已过期");
            localStorage.removeItem("token");
            localStorage.removeItem("username");
            localStorage.removeItem("permission");
            this.$router.push({ path: "/login" });
            return;
          }

          let res = await this.$RequestUtil.postAsync({ url, type: "sync", dataType: "blob", params: { exportSplitId: [this.selectedSplit.splitItemId] } });
          let xls = new Blob([res], { type: "application/application/vnd.ms-excel;charset=utf-8" });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(xls); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = text; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch(() => {});
    },
    CancellationClick(row) {
      for (let i = 0; i < this.pickMaterialsList.length; i++) {
        this.pickList = this.pickMaterialsList[i];
        // console.log(this.pickList.id);
        // console.log(this.pickList.needAmount);
        // console.log(this.pickList.pickAmount);
      }
      this.$confirm("取消领料将释放剩余锁定库存, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$RequestUtil.post({
            url: "/api/pickMaterial/CancelOffset",
            params: {
              splitId: this.clickLookForm.splitId,
              pickId: row.pickId,
              orderCode: this.selectedSplit.orderCode,
              materialId: row.materialId,
              needAmount: row.needAmount,
              pickAmount: row.pickAmount
            },
            success: res => {
              if (res.result == this.$Global.RESPONSE.SUCCESS) {
                this.$message({
                  type: "success",
                  message: "取消领料成功!"
                });
                this.pickList.needAmount = this.pickList.pickAmount;
                this.MaterialDialogClick();
                this.MaterialDialogVisible = false;
              } else {
                this.$message({
                  type: "error",
                  message: res.message
                });
              }
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    materialClick(row) {
      for (let i = 0; i < this.pickMaterialsList.length; i++) {
        this.pickList = this.pickMaterialsList[i];
        // console.log(this.pickList.id);
        // console.log(this.pickList.needAmount);
        // console.log(this.pickList.pickAmount);
      }
      this.$confirm("确定自动完成剩余领料任务?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$RequestUtil.post({
            url: "/api/pickMaterial/accomplishPickMaterial",
            params: {
              splitId: this.clickLookForm.splitId,
              orderCode: this.selectedSplit.orderCode,
              pickId: row.pickId,
              materialId: row.materialId,
              needAmount: row.needAmount,
              pickAmount: row.pickAmount
            },
            success: res => {
              if (res.result == this.$Global.RESPONSE.SUCCESS) {
                this.$message({
                  type: "success",
                  message: "完成领料成功!"
                });
                // this.MaterialDialogClick();
                this.MaterialDialogVisible = false;
              } else {
                this.$message({
                  type: "error",
                  message: res.message
                });
              }
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    async showUpdataCount(rowData) {
      if (rowData.productionType == 2 || rowData.productionType == 4) {
        this.form.planId = rowData.planId;
      } else {
        this.form.planId = rowData.subPlanId;
      }
      let {
        data: { dataList },
        code,
        msg,
        message
      } = await this.$RequestUtil.getAsync({ url: "/api/productionPlan/listSubmit", type: "sync", params: { planId: this.form.planId } });
      if (code == 0) {
        this.dataList = dataList;
        this.form.dataList = dataList;
        this.isShowDialog = true;
      } else {
        this.$message.error(message || msg);
      }
    },

    updataCount() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          let dataList = this.dataList.map(item => {
            return { id: item.id, actualAmount: item.actualAmount, actualUnqualifiedProcessCount: item.actualUnqualifiedProcessCount, actualSpoiledProcessCount: item.actualSpoiledProcessCount };
          });
          this.$RequestUtil.post({
            url: "/api/productionPlan/updateActualFinishedAmount",
            type: "sync",
            params: {
              planId: this.form.planId,
              dataList
            },
            success: res => {
              if (res.code == 0) {
                this.$message.success("修改成功");
                this.loadPartData(this.selectedSplit.splitItemId);
                this.isShowDialog = false;
              } else {
                this.$message.error(res.message || res.msg);
              }
            }
          });
        }
      });
    },

    handleClick(ev) {
      if (this.activeName == 1) {
        this.loadErrReport();
      }
    },

    loadErrReport() {
      this.$RequestUtil.get({
        url: "/api/productionPlan/getProblemReport",
        type: "sync",
        params: {
          planId: this.planId
        },
        success: res => {
          if (res.code == 0) {
            // this.$message.success('添加成功')
            let arr = [];
            res.data.forEach(item => {
              item.problemPlans.forEach(p => {
                //不合格
                if (p.unqualifiedProcessCount) {
                  arr.push({
                    type: "不合格",
                    workerName: p.workerName,
                    count: p.unqualifiedProcessCount,
                    reason: p.unqualifiedReason,
                    time: p.gmtCreate,
                    procedureName: item.procedureName
                  });
                }
                //报废
                if (p.spoiledProcessCount) {
                  arr.push({
                    type: "报废",
                    count: p.spoiledProcessCount,
                    reason: p.scrapReason,
                    workerName: p.workerName,
                    time: p.gmtCreate,
                    procedureName: item.procedureName
                  });
                }
              });
            });
            this.errList = arr;
          } else {
            this.$message.error(res.msg || res.message);
          }
        }
      });
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      let num = 4;
      if (this.selectedSplit.splitPlanType == 2) {
        num = 3;
      }
      if (columnIndex < num || columnIndex == 6 || columnIndex == 15 || columnIndex == 16) {
        if (row.len) {
          return {
            rowspan: row.len,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },

    /**
     * 根据返回的isError 来判断是非高亮显示
     */
    showCellClass({ row, column, rowIndex, columnIndex }) {
      if (row.isError) {
        if (columnIndex > 7 && columnIndex < 14) {
          return "show-highlight";
        }
      }
    },

    getFilePath(fileName) {
      if (!fileName) {
        return;
      }
      let filePath = "";
      let arr = fileName.split(".");
      let suffix = arr[arr.length - 1];
      switch (true) {
        case suffix == "pdf" || suffix == "pptx":
          filePath = "/static/img/pdf.png";
          break;
        case suffix == "png" || suffix == "jpg" || suffix == "svg":
          filePath = "/static/img/pic.png";
          break;
        case suffix == "txt" || suffix == "doc" || suffix == "docx":
          filePath = "/static/img/txt.png";
          break;

        default:
          filePath = "/static/img/file.png";
      }
      return filePath;
    },

    showFile: function(url) {
      if (!this.permission.btn_file_get) {
        this.$message({
          type: "error",
          message: `抱歉，您暂无文件读取权限`
        });
        return false;
      }
      if (!url) {
        this.$message.warning("当前文件不存在");
        return;
      }
      let index = url.lastIndexOf(".");
      let ext = url.substr(index + 1).toLowerCase();
      //可直接被浏览器打开的文件类型
      let arr = ["pdf", "png", "jpg", "svg", "txt", "html", "js", "art", "au", "aiff", "xbf", "jpeg"];
      if (arr.includes(ext)) {
        window.open(url, "_blank");
      } else {
        window.location.href = url;
      }
    },

    submitAddQcTask(rowData) {
      this.$RequestUtil.post({
        url: "/api/qcTask/addPollingTask",
        type: "sync",
        params: {
          planIds: rowData.planIds
        },
        success: res => {
          if (res.code == 0) {
            this.$message.success("添加成功");
            this.loadPartData(this.selectedSplit.splitItemId);
          } else {
            this.$message.error(res.msg || res.message);
          }
        }
      });
    },

    /**
		 * @description: 
		 * @param {type} 
		 * @return {type} 
		 * 1.扫码设备存在
			1.1) 编排任务设备存在  
				a. 设备一致     显示扫码设备 绿色
				b. 设备不一致   显示扫码设备  红色
			1.2)编排任务设备不存在
				显示扫码设备  颜色黄色

			2.扫码设备不存在
				2.1) 编排任务设备存在  显示编排任务设备 颜色无
				2.2)编排任务设备不存在  空  
		*/

    parseDevice(row) {
      let deviceCode = "";
      if (row.scanDeviceCode) {
        deviceCode = row.scanDeviceCode;
      } else {
        deviceCode = row.deviceCode;
      }
      return deviceCode;
    },

    cellStyle({ row, column, rowIndex, columnIndex }) {
      let style = {};
      if (row.scanDeviceCode) {
        if (row.deviceCode) {
          if (row.deviceCode == row.scanDeviceCode) {
            style = { background: "green", color: "#fff" };
          } else {
            style = { background: "red", color: "#fff" };
          }
        } else {
          style = { background: "yellow", color: "#000" };
        }
      }
      if (column.label == "设备编号") {
        return style;
      }
    },

    loadPartData(splitItemId) {
      this.$RequestUtil.get({
        url: "/api/productionPlan/listPartProcessByPartPlan",
        type: "sync",
        params: {
          splitItemId
        },
        success: res => {
          let arr = [];
          res.data.forEach((item, itemIndex) => {
            if (item.startTime) {
              item.startTime = commonUtils.timestampToDate(item.startTime, true);
            }
            if (item.planningEndTime) {
              item.planningEndTime = commom.timestampToDate(item.planningEndTime, true);
            }
            if (this.selectedSplit.productionType == 1 || this.selectedSplit.productionType == 0) {
              if (item.startTime) {
                item.planTime = item.startTime + "—" + item.planningEndTime;
              }
            }

            if (item.technologyFileName) {
              item.filePath = this.getFilePath(item.technologyFileName);
            }

            if (this.selectedSplit.productionType == 3 && (!item.deviceCode || item.deviceCode == "无")) {
              item.deviceCode = "";
            }
            if (!item.deviceCode && this.selectedSplit.productionType != 3) {
              item.deviceCode = "";
            }
            if (this.selectedSplit.productionType == 2 || this.selectedSplit.productionType == 4) {
              item.procedureIndex = 1;
            } else {
            }
            if (!item.workerName) {
              item.workerName = "";
            }
            item.finishedAmount = item.qualifiedProcessCount;
            if (this.selectedSplit.productionType == 1 || this.selectedSplit.productionType == 0) {
              if (item.processList.length > 1) {
                let allCount = 0;
                let finishedAmount = 0;
                item.processList.forEach(s => {
                  allCount += s.actualFinishedAmount;
                  finishedAmount += s.qualifiedProcessCount;
                });
                log(allCount, "allCount");
                item.planIds = item.processList.map(p => p.planId);

                item.processList.forEach((subItem, index) => {
                  if (index == 0) {
                    subItem.len = item.processList.length;
                  }
                  subItem.subPlanId = subItem.planId;
                  subItem.index = itemIndex + 1;
                  // subItem.planningEndTime = item.planningEndTime
                  // subItem.startTime = item.startTime
                  subItem.technologyFileId = item.technologyFileId;
                  subItem.technologyFileName = item.technologyFileName;
                  subItem.technologyFileUrl = item.technologyFileUrl;
                  subItem.amountOfPollingTask = item.amountOfPollingTask;
                  // subItem.productionEfficiency = item.productionEfficiency
                  // subItem.isError = item.isError
                  subItem.procedureIndex = item.procedureIndex;
                  subItem.procedureName = item.procedureName;
                  subItem.productionCount = item.productionCount;
                  subItem.filePath = item.filePath;
                  // subItem.groupName=item.groupName
                  if (this.selectedSplit.splitPlanType == 2) {
                    if (subItem.planningEndTime) {
                      subItem.planTime = commom.timestampToDate(subItem.startTime, true) + "—" + commom.timestampToDate(subItem.planningEndTime, true);
                    }
                  } else {
                    subItem.planTime = item.planTime;
                  }

                  subItem.planIds = item.planIds;
                  subItem.totalProcessStatus = item.totalProcessStatus;
                  // subItem.qualifiedProcessCount = item.qualifiedProcessCount
                  subItem.finishedAmount = finishedAmount;
                  // subItem.executeCount = item.executeCount
                  this.parseProgress(subItem, subItem.executeCount, allCount);
                  arr.push(subItem);
                });
              } else {
                item.planIds = item.processList.map(p => p.planId);
                item.len = 1;
                item.index = itemIndex + 1;
                item.workerName = item.processList[0].workerName;
                item.deviceCode = item.processList[0].deviceCode;
                item.groupName = item.processList[0].groupName;
                item.productionEfficiency = item.productionEfficiency;
                item.isError = item.processList[0].isError;
                item.actualStartTime = item.processList[0].actualStartTime;
                item.actualEndTime = item.processList[0].actualEndTime;
                item.actualFinishedAmount = item.processList[0].actualFinishedAmount;
                item.unqualifiedProcessCount = item.processList[0].unqualifiedProcessCount;
                item.qualifiedProcessCount = item.qualifiedProcessCount;
                item.subPlanId = item.processList[0].planId;
                item.planState = item.processList[0].planState;
                item.executeCount = item.processList[0].executeCount;
                item.operationalWasteCount = item.processList[0].operationalWasteCount;
                item.actualOperationalWasteCount = item.processList[0].actualOperationalWasteCount;
                item.materialWasteCount = item.processList[0].materialWasteCount;
                item.actualMaterialWasteCount = item.processList[0].actualMaterialWasteCount;
                if (this.selectedSplit.splitPlanType == 2) {
                  if (item.processList[0].planningEndTime) {
                    item.planTime = commom.timestampToDate(item.processList[0].startTime, true) + "—" + commom.timestampToDate(item.processList[0].planningEndTime, true);
                  }
                }

                item.spoiledProcessCount = item.processList[0].spoiledProcessCount;
                this.parseProgress(item, item.executeCount, item.actualFinishedAmount);
                arr.push(item);
              }
            }
          });
          this.splitType = res.data[0].splitType;
          if (this.selectedSplit.productionType == 1 || this.selectedSplit.productionType == 0) {
            this.progressData = arr;
            this.planId = arr[0].planId;
          } else {
            this.progressData = res.data;
          }
        }
      });
    },

    addQcTask(rowData) {
      if (rowData.amountOfPollingTask && rowData.amountOfPollingTask > 0) {
        this.$confirm("该任务已经生成过子卷质量检任务，是否再次生成?", "提示", {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.submitAddQcTask(rowData);
        });
      } else {
        this.submitAddQcTask(rowData);
      }
    },

    backToOrderItemView() {
      this.$parent.reload(this.selectedSplit.page);
      this.$parent.showPage = 1;
    },

    parseProgress(item, productionCount, allCount) {
      productionCount = productionCount || this.selectedSplit.splitCount;
      item.progress = Math.round((allCount / productionCount) * 100);

      if (item.progress > 100) {
        item.progress = 100;
      }
      // if(item.planState==2){
      //     item.color = 'rgb(255,86,34)'
      // }else{

      // }
      if (item.progress == 0) {
        item.color = "rgb(244,246,245)";
      } else if (item.progress > 0 && item.progress < 100) {
        item.color = "rgb(255,186,1)";
      } else if (item.progress == 100) {
        item.color = "rgb(108,213,137)";
      }
    },
    getProgress(item) {
      let progress = item.progress;

      if (progress > 100) {
        progress = 100;
      }
      if (progress == 0) {
        item.color = "rgb(244,246,245)";
      } else if (progress > 0 && progress < 100) {
        item.color = "rgb(255,186,1)";
      } else if (progress == 100) {
        item.color = "rgb(108,213,137)";
      }
      return progress;
    },
    parseTime: function(rowData) {
      if (rowData.time != null) {
        let dateString = commonUtils.timestampToDate(rowData.time, false);
        return dateString;
      }
    },
    parseStatus(ev) {
      let orderStatusOptions = [
        // 0-未排产 1-已排产 2-已派工 3-生产中 4-已完成
        { id: 0, label: "未排产", value: 0 },
        { id: 6, label: "工艺已分解", value: 6 },
        { id: 1, label: "已排产", value: 1 },
        { id: 2, label: "已下达", value: 2 },
        { id: 3, label: "生产中", value: 3 },
        { id: 4, label: "已完成", value: 4 },
        { id: 5, label: "已关闭", value: 5 },
        { id: 7, label: "工序派工", value: 7 }
      ];
      if (ev != null && ev != undefined) {
        this.selectedSplit.splitStatusText = (orderStatusOptions.find(item => item.value == ev) || {}).label;
      }
    }
  },
  watch: {},
  filters: {
    showSubmitTime(ev, show) {
      if (ev) {
        return commonUtils.timestampToDate(ev, show);
      } else {
        return " ";
      }
    }
  }
};
</script>

<style scoped>
#ProductionProgressView {
  /* padding-bottom: 30px;
    margin-bottom: 30px; */
}

/* .order_product_table{
      width: 98%
  } */
.file-icon-container {
  width: 36px;
  height: 45px;
  margin-top: 0px;

  background-size: cover;
  position: relative;
  cursor: pointer;
}

.order_item_title {
  margin-top: 10px;
  font-size: 22px;
}

.margin_left_15 {
  margin-left: 15px;
  padding: 8px 0;
}

.operateBtn-wrap {
  margin-top: 0px;
}

.label {
  display: inline-block;

  height: 32px;
  line-height: 32px;
  font-size: 14px;
  color: #606266;
  width: 72px;
  text-align: right;
}

.value {
  display: inline-block;
  width: 200px;
  /* height: 32px; */
  line-height: 32px;
  font-size: 12px;
  color: #606266;
  vertical-align: top;
}

@media screen and (min-width: 1280px) and (max-width: 1366px) {
  .value {
    width: 150px !important;
  }
}

.progress_table {
}
.y_lookValue {
  font-size: 12px;
  color: #409eff;
  cursor: pointer;
}
</style>

<style>
/*  */
/* @media screen and (min-width:1441px) {
        .order_product_table .progress_table .el-table__body-wrapper {
            max-height:400px !important ;
            overflow-y:auto !important ;
            
        }
    } */

/* @media screen and (max-width: 1440px) and (min-width: 1367px) {
    .order_product_table .progress_table .el-table__body-wrapper {
      max-height: 350px !important;
      overflow-y: auto !important;
    }
  } */

/* @media screen and (max-width: 1366px) {
    .order_product_table .progress_table .el-table__body-wrapper {
      max-height: 300px !important;
      overflow-y: auto !important;
    }
  } */
#ProductionProgressView .el-form-item--mini.el-form-item,
#ProductionProgressView .el-form-item--small.el-form-item {
  margin-bottom: 14px;
  margin-top: 2px;
}

.show-highlight {
  background: #ffffcc;
}

.y_flex {
  display: flex;
}

.y_flex span:nth-child(1) {
  width: 80px;
  height: 30px;
  display: inline-block;
  line-height: 30px;
  text-align: right;
  align-self: center;
}

.y_flex span:nth-child(2) {
  flex: 1;
  align-self: center;
  height: 30px;
  line-height: 30px;
  display: inline-block;
  font-size: 12px;
  color: #606266;
}
</style>



// WEBPACK FOOTER //
// src/views/order/ProductionTask/ProductionProgressView.vue